import { render, staticRenderFns } from "./SmartPrepaidBalance.vue?vue&type=template&id=6f04925b&scoped=true&"
import script from "./SmartPrepaidBalance.vue?vue&type=script&lang=js&"
export * from "./SmartPrepaidBalance.vue?vue&type=script&lang=js&"
import style0 from "./SmartPrepaidBalance.vue?vue&type=style&index=0&id=6f04925b&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6f04925b",
  null
  
)

export default component.exports